import Lang from '@/core/lang';
import Reporting from '@/core/reporting';
import Toast from '@/core/toast/toast';
import Swal from 'sweetalert2';
import Http from './http';
import Router from './router/router';

export const routerService = new Router();
export const httpService = new Http();
export const alertService = Swal.mixin({
  iconHtml: '<svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
    '<circle cx="19" cy="19" r="19" fill="#F6B72D"/>\n' +
    '<path d="M18.1758 11.0039L18.4688 22.207H20.5312L20.8242 11.0039H18.1758ZM18.0117 25.793C18.0117 26.6133 18.6797 27.2227 19.5 27.2227C20.3203 27.2227 20.9883 26.6133 20.9883 25.793C20.9883 24.9727 20.3203 24.3633 19.5 24.3633C18.6797 24.3633 18.0117 24.9727 18.0117 25.793Z" fill="white"/>\n' +
    '</svg>',
});
export const langService = new Lang();
export const toastService = new Toast();
export const reportService = new Reporting();
